import { Alert, Form, Input, Modal, notification } from 'antd';
import React, { useState } from 'react';
import totpService from '../../../services/admin/totp.service';

const Reset2faModal = ({ open, account, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [state, setState] = useState({
        loading: false,
        error: null,
    });

    const onSubmit = async () => {
        const { totp_code } = form.getFieldsValue();
        setState(s => ({ ...s, loading: true, error: null }));
        const res = await totpService.adminReset(account?.account_id, totp_code).catch(err => {
            setState(s => ({
                ...s,
                loading: false,
                error: err?.response?.data?.message || 'Failed to reset 2FA',
            }));
            return null;
        });
        if (!res) return;
        notification.success({ message: res.message || '2FA reset successfully.' });
        setState({ loading: false, error: null });
        form.resetFields();
        onSuccess?.();
    };

    const handleClose = () => {
        form.resetFields();
        setState({ loading: false, error: null });
        onClose?.();
    };

    return (
        <Modal
            open={open}
            title={`Reset 2FA — ${account?.username ?? ''}`}
            onCancel={handleClose}
            onOk={() => form.submit()}
            okText="Reset 2FA"
            okButtonProps={{ danger: true, loading: state.loading }}
            destroyOnClose
        >
            <Form form={form} onFinish={onSubmit} layout="vertical">
                <p style={{ marginBottom: 16, color: 'var(--secondary-text-color)' }}>
                    Enter your own current 6-digit authenticator code to reset 2FA for{' '}
                    <strong>{account?.username}</strong>.
                </p>
                <Form.Item name="totp_code" label="Your 2FA code">
                    <Input
                        autoFocus
                        placeholder="6-digit code"
                        maxLength={6}
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        style={{ width: 200 }}
                        onChange={e => {
                            const val = e.target.value.replace(/\D/g, '');
                            form.setFieldValue('totp_code', val);
                            if (state.error) setState(s => ({ ...s, error: null }));
                        }}
                    />
                </Form.Item>
                {state.error && (
                    <Alert type="error" message={state.error} showIcon />
                )}
            </Form>
        </Modal>
    );
};

export default Reset2faModal;
